/**
 * Company Interceptor — Story 110.7
 *
 * Добавляет X-Company-ID заголовок ко всем запросам к /api/v1/
 * для передачи UI-фокуса активной организации.
 *
 * Зеркалирует cabinetInterceptor (Story 21.9).
 * Зарегистрирован в app.config.ts ПОСЛЕ cabinetInterceptor.
 *
 * Инертен пока ORG_SCOPE_ENABLED=False на бэке (110.6).
 */
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OrgStateService } from '../services/org-state.service';

export const companyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/v1/')) {
    return next(req);
  }

  const orgState = inject(OrgStateService);
  const companyId = orgState.activeOrgId();

  if (!companyId) {
    return next(req);
  }

  // Cache-bust param: гарантируем уникальный URL per-company (аналог _cab= в cabinetInterceptor)
  const separator = req.url.includes('?') ? '&' : '?';
  const cacheBustUrl = `${req.url}${separator}_org=${companyId.slice(0, 8)}`;

  const clonedReq = req.clone({
    url: cacheBustUrl,
    setHeaders: {
      'X-Company-ID': companyId,
    },
  });
  return next(clonedReq);
};
